/**
 * 将底层数据转换为 client 端数据
 */

import {
    type IAdvancedTextMaterial,
    type IFontGlow,
    type IFontShadow,
    type IFontStroke,
    type ITextLayerProps,
    type IVectorLayerProps,
} from '@/version-types';

export const transformLetterSpacingToStage = (letterSpacing: number, fontSize: number) => {
    return (letterSpacing / 1000) * fontSize;
};

export const transformLineSpacingToStage = (lineSpacing: number) => {
    return lineSpacing / 1000 + 1.2;
};

export const transformGlowToStage = (textGlow: IFontGlow[], fontSize: number) => {
    return textGlow?.map((glow) => {
        return {
            ...glow,
            width: ((glow.width * 25) / 512) * fontSize,
        };
    });
};

export const transformShadowToStage = (textShadow: IFontShadow[], fontSize: number) => {
    return textShadow?.map((shadow) => {
        return {
            ...shadow,
            blur: ((shadow.blur * fontSize) / 128) * 5,
        };
    });
};

export const transformStrokeToStage = (textStroke: IFontStroke[], fontSize: number) => {
    return textStroke?.map((stroke) => {
        /** app 转换 */
        const width = ((stroke.width * fontSize) / 128) * 5;
        /** 竞品换算 */
        // const width = stroke.width;
        return {
            ...stroke,
            width,
        };
    });
};

export const transformArtTextDataToStage = (data: IAdvancedTextMaterial) => {
    const defaultLetterSpacing = transformLetterSpacingToStage(
        data.material.defaultLetterSpacing,
        data.material.defaultFontSize,
    );
    const textContents = data.textContents.map((item) => {
        const ret = { ...item };

        if (item.textStroke && item.textStroke.length > 0) {
            ret.textStroke = transformStrokeToStage(item.textStroke, data.material.defaultFontSize);
        }

        if (item.textShadow && item.textShadow.length > 0) {
            ret.textShadow = transformShadowToStage(item.textShadow, data.material.defaultFontSize);
        }

        if (item.textGlow && item.textGlow.length > 0) {
            ret.textGlow = transformGlowToStage(item.textGlow, data.material.defaultFontSize);
        }

        return ret;
    });

    return {
        id: data.id,
        material: { ...data.material, defaultLetterSpacing },
        textContents,
    };
};

export const transformLowLeverTextDataToCss = (textData: ITextLayerProps) => {
    let result = {
        ...textData,
    };

    const { textGlow, textShadow, textStroke } = textData;
    const { fontSize, lineSpacing, letterSpacing } = textData;

    result = {
        ...result,
        textGlow,
        textShadow,
        textStroke,
    };

    result.letterSpacing = transformLetterSpacingToStage(letterSpacing, fontSize);
    result.lineSpacing = transformLineSpacingToStage(lineSpacing);
    result.textGlow = transformGlowToStage(textGlow, fontSize);
    result.textShadow = transformShadowToStage(textShadow, fontSize);
    result.textStroke = transformStrokeToStage(textStroke, fontSize);

    if (textData.advancedTextMaterial) {
        result.advancedTextMaterial = transformArtTextDataToStage(textData.advancedTextMaterial);
    }

    return result;
};

export const transformFoundationVectorLayerDataToClient = (layerData: IVectorLayerProps) => {
    const { textInfo } = layerData;
    if (!textInfo) return layerData;

    const { fontSize, lineSpacing, letterSpacing } = textInfo;
    const nextTextInfo = {
        ...textInfo,
        lineSpacing: transformLineSpacingToStage(lineSpacing),
        letterSpacing: transformLetterSpacingToStage(letterSpacing, fontSize),
    };
    const nextLayerData: IVectorLayerProps = {
        ...layerData,
        textInfo: nextTextInfo,
    };

    return nextLayerData;
};
